module.exports = __webpack_public_path__ + "img/icon-sale-search2.8ff2e3f7.png";